export default __webpack_public_path__ + "static/media/about-music.76e4a96f.jpg";